import Link from "next/link";
import { footerMenuList, socialIcons } from "../data/footer_data";
import Image from "next/image";
import Logo from "./../public/logo/black.png";
// import WhiteLogo from "./../public/logo/white.png";
import WhiteLogo from "./../public/logo/colored_white.png";

const footer = () => {
  const date = new Date();
  return (
    <>
      {/* <!-- Footer --> */}
      <div className="dark:bg-[#1a1437] bg-gray-700 py-6 px-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
          {/* Logo Section */}
          <div className="mb-4 md:mb-0">
            {/*
            In a real application, replace this with an actual image tag for your logo:
            <img src="/path/to/your/logo.png" alt="Impactoverse Logo" className="h-10" />
            For now, we'll use a stylized text representation as seen in the image.
          */}
            <div className="flex items-end">
              <Link href="#" className="mb-4 mt-4 inline-block">
                <Image
                  height={90}
                  width={190}
                  src={Logo}
                  className="max-h-7 dark:hidden"
                  alt="Impactoverse | Impact Ecosystem"
                />
              </Link>

              <Link href="#" className=" mb-0 mt-6 inline-block">
                <Image
                  height={90}
                  width={190}
                  src={WhiteLogo}
                  className="hidden max-h-7 dark:block mb-6"
                  alt="Impactoverse | Impact Ecosystem"
                />
              </Link>
            </div>
          </div>

          {/* Social Media Icons */}
          <div className="flex space-x-6">
            {socialIcons.map((item) => {
              const { id, href, text } = item;
              return (
                <Link
                  href={href}
                  key={id}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-blue-400 group cursor-pointer"
                >
                  <svg className="icon group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white">
                    <use xlinkHref={`/icons.svg#icon-${text}`}></use>
                  </svg>
                </Link>
              );
            })}
            {/* <a href="#" aria-label="Facebook" className="text-white hover:text-blue-400">
            <FacebookIcon />
          </a>
          <a href="#" aria-label="X (Twitter)" className="text-white hover:text-blue-400">
            <XIcon />
          </a>
          <a href="#" aria-label="Instagram" className="text-white hover:text-blue-400">
            <InstagramIcon />
          </a>
          <a href="#" aria-label="TikTok" className="text-white hover:text-blue-400">
            <TikTokIcon />
          </a> */}
          </div>
        </div>
      </div>
      <footer className="dark:bg-jacarta-900 page-footer bg-white py-10 px-5">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Us Section */}
          <div className="mb-6 md:mb-0">
            <h3 className="text-lg font-bold mb-4">ABOUT US</h3>
            <p className="text-sm leading-relaxed text-gray-300">
              Join a purpose-driven ecosystem that benefits both people and the
              planet. Whether through play, art, or ethical commerce, every
              interaction helps you shape a better future.
            </p>
          </div>
          {footerMenuList.map((single) => (
            <div className={`mb-6 md:mb-0`} key={single.id}>
              <h3 className="text-lg font-bold mb-4">{single.title}</h3>
              <ul className="dark:text-jacarta-300 text-sm space-y-2 text-gray-300">
                {single.list.map((item) => {
                  const { id, href, text } = item;
                  return (
                    <li key={id}>
                      <Link
                        target="_blank"
                        href={href}
                        className="hover:text-accent dark:hover:text-white"
                      >
                        {text}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
          {/*
        <div className="mb-6 md:mb-0">
          <h3 className="text-lg font-bold mb-4">CHECK IT OUT</h3>
          <ul className="text-sm space-y-2 text-gray-300">
            <li><a href="#" className="hover:text-blue-400 transition-colors duration-200">FAQS</a></li>
            <li><a href="#" className="hover:text-blue-400 transition-colors duration-200">PRIVACY</a></li>
            <li><a href="#" className="hover:text-blue-400 transition-colors duration-200">TERMS AND CONDITIONS</a></li>
          </ul>
        </div>

         
        <div className="mb-6 md:mb-0">
          <h3 className="text-lg font-bold mb-4">FIND OUT MORE</h3>
          <ul className="text-sm space-y-2 text-gray-300">
            <li><a href="#" className="hover:text-blue-400 transition-colors duration-200">WORLD OF IMPACT</a></li>
            <li><a href="#" className="hover:text-blue-400 transition-colors duration-200">IMPACT CAMPAIGNS</a></li>
            <li><a href="#" className="hover:text-blue-400 transition-colors duration-200">ABOUT US</a></li>
          </ul>
        </div> */}

          {/* Newsletter Section */}
          <div>
            <h3 className="text-lg font-bold mb-4">NEWSLETTER</h3>
            <form>
              <input
                type="email"
                placeholder="Email"
                className="w-full dark:bg-white p-3 rounded-3xl bg-gray-100 text-gray-800 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-full"
              />

              <button className="uppercase w-full bg-accent shadow-accent-volume hover:bg-accent-light hover:bg-accent-dark inline-block rounded-full py-3 px-8 text-center font-semibold text-white transition-all">
                SEND
              </button>
            </form>
          </div>
        </div>

        {/* Copyright Notice */}
        <div className="border-t  border-[#34313c5c] mt-12 pt-8 text-center text-sm text-gray-400 text-center">
          <ul className="dark:text-jacarta-400 flex flex-wrap justify-center space-x-4 text-sm mx-auto text-center">
            <li>
              <Link
                href="/terms-of-service"
                className="hover:text-accent dark:hover:text-white"
              >
                Terms and Conditions
              </Link>
            </li>
            <li className="hidden md:block"> |</li>
            <li>
              <Link
                href="/privacy-policy"
                className="hover:text-accent dark:hover:text-white"
              >
                Privacy Policy
              </Link>
            </li>
            <li className="hidden md:block">
              {" "}
              | &nbsp;&nbsp;&nbsp;Copyright Impactoverse {date.getFullYear()}
            </li>
          </ul>
        </div>
      </footer>
      {/* <footer className="dark:bg-jacarta-900 page-footer bg-white">
        <div className="container">
          <div className="grid grid-cols-6 gap-x-7 gap-y-14 pt-24 pb-12 md:grid-cols-12">
            <div className="col-span-12 md:col-span-4">
           
              <Link href="#" className="mb-6 inline-block">
                <Image
                  height={90}
                  width={190}
                  src={Logo}
                  className="max-h-7 dark:hidden"
                  alt="Impactoverse | Impact Ecosystem"
                />
              </Link>

              <Link href="#" className=" mb-6 inline-block">
                <Image
                  height={90}
                  width={190}
                  src={WhiteLogo}
                  className="hidden max-h-7 dark:block mb-6"
                  alt="Impactoverse | Impact Ecosystem"
                />
              </Link>
              <p className="dark:text-jacarta-300 mb-12">
                Shape a better future. Join a cause-driven community, back
                campaigns you care about, align with purposeful brands and
                influencers, and build an impact portfolio that benefits you and
                the planet.
              </p>

              <div className="flex space-x-5">
                {socialIcons.map((item) => {
                  const { id, href, text } = item;
                  return (
                    <Link
                      href={href}
                      key={id}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group cursor-pointer"
                    >
                      <svg className="icon group-hover:fill-accent fill-jacarta-300 h-5 w-5 dark:group-hover:fill-white">
                        <use xlinkHref={`/icons.svg#icon-${text}`}></use>
                      </svg>
                    </Link>
                  );
                })}
              </div>
            </div>

            {footerMenuList.map((single) => (
              <div
                className={`col-span-6 sm:col-span-6 md:col-span-3 ${single.diffClass}`}
                key={single.id}
              >
                <h3 className="font-display text-jacarta-700 mb-6 text-lg dark:text-white">
                  {single.title}
                </h3>
                <ul className="dark:text-jacarta-300 flex flex-col space-y-1">
                  {single.list.map((item) => {
                    const { id, href, text } = item;
                    return (
                      <li key={id}>
                        <Link
                          target="_blank"
                          href={href}
                          className="hover:text-accent dark:hover:text-white"
                        >
                          {text}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>

          <div className="flex flex-col items-center justify-center justify-between space-y-2 py-8 sm:flex-row sm:space-y-0">
         

            <ul className="dark:text-jacarta-400 flex flex-wrap space-x-4 justify-center text-sm mx-auto text-center">
              <li>
                <Link
                  href="/terms-of-service"
                  className="hover:text-accent dark:hover:text-white"
                >
                  Terms and Conditions
                </Link>
              </li>
              <li className="hidden md:block"> |</li>
              <li>
                <Link
                  href="/privacy-policy"
                  className="hover:text-accent dark:hover:text-white"
                >
                  Privacy Policy
                </Link>
              </li>
              <li className="hidden md:block">
                {" "}
                | &nbsp;&nbsp;&nbsp;Copyright Impactoverse {date.getFullYear()}
              </li>
            </ul>
          </div>
        </div>
      </footer> */}
    </>
  );
};

export default footer;
